import { Routes, Route } from "react-router-dom";
import AddNewRegion from "../pages/dashboardPage/regionSettings/addNewRegion/AddNewRegion";
import AllRegions from "../pages/dashboardPage/regionSettings/allRegions/AllRegions";
import EditRegion from "../pages/dashboardPage/regionSettings/editRegion/EditRegion";
import RegionImages from "../pages/dashboardPage/regionSettings/regionImages/RegionImages";

const RegionNavigator = () => {
  return (
    <Routes>
      <Route path="/show-all-regions" element={<AllRegions />} />
      <Route path="/add-new-region" element={<AddNewRegion />} />
      <Route path="/edit-region" element={<EditRegion />} />
      <Route path="/edit-regions-images" element={<RegionImages />} />
      <Route path="*" element={<AllRegions />} />
    </Routes>
  );
};

export default RegionNavigator;
